export const styles = (theme) => ({
  content: {
    backgroundColor: 'transparent',
  },
});
